__turbopack_context__.v({
  "className": "andika_a6aa2662-module__57C11W__className",
});
